/**
 * ? @description : To Show Mapped Data Modal Component
 */

// Dependencies
import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch } from "react-redux";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  Checkbox,
} from "@mui/material";

// Axios Component
import Axios from "../../../../../axios/Axios";

// Redux Component
import { showSnackbar } from "../../../../redux/features/appSlice";
// import { useEffect } from "react";

function MappedDataModal(props) {
  // console.log(props.mappedvalues);
  // * Logged Username
  const user = sessionStorage.getItem("user_id");

  // * Redux
  const dispatch = useDispatch();

  // * Data Initialization
  
  // * State Variables
  // const [data, setData] = useState([]);
  // console.log(data, " - data");
  // console.log(props.mappedvalues, " - mappedvalues");
  const [selected, setSelected] = useState([]);
  // const [page, setPage] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(5);


  //Setting props.mappedvalues to new state 
  // useEffect(() => {
  //   setData(props.mappedvalues);
  // },[mappedValueStringified, props.mappedvalues])

  // * Modal Close
  const closeModal = (props) => {
    props.onHide();
  };

  // ! Handle Checkbox Selection
  const handleClick = (event, name) => {
    
    const selectedIndex = selected.indexOf(name);

    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    } else {
      console.log("Error");
    }

    setSelected(newSelected);
  };
  // console.log(selected, " - selected state");
  // * Handle Row Selection
  const isSelected = (name) => selected.indexOf(name) !== -1;

  // * Handle Pagination
  // const handleChangePage = (event, newPage) => {
  //   setPage(newPage);
  // };

  // * Handle Rows Per Page
  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(+event.target.value);
  //   setPage(0);
  // };

  // * Table Custom Styles
  const useStyles = makeStyles((theme) => ({
    table: {
      minWidth: 650,
    },
    tableContainer: {
      borderRadius: 10,
    },
    tableHeaderCell: {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.getContrastText(theme.palette.primary.dark),
      fontWeight: "bold",
      fontSize: "1rem",
    },
    teacherName: {
      color: "#BC720C",
    },
    studentName: {
      color: "#5112FC",
    },
  }));

  // * useStyles Initialization
  const classes = useStyles();

  // ! Create Mapped Data in Array Format

  const formMappedData = selected.map((item) => {
    return {
      teacher_id: props.mappedvalues[item].teacherId,
      teacher_name: props.mappedvalues[item].teacherName,
      student_id: props.mappedvalues[item].studentId,
      student_name: props.mappedvalues[item].studentName,
      batch_id: props.mappedvalues[item].teacherBatchId,
      batch_name: props.mappedvalues[item].teacherBatchName,
      map_created_by: user,
    }
    
  });
  // console.log(formMappedData);
  // * Function Call to Create Array of Mapped Data
  // formMappedData = createArrayValues();

  // ? Post Method : Store Mapped Data to the Server
  async function postMappedData() {
    try {

      if (formMappedData.length > 0) {
        // * API Call
        let option = {
          method: "POST",
          url: "/mapping",
          auth: true,
          data: formMappedData,
        };

        const response = await Axios(
          option.method,
          option.url,
          option.auth,
          option.data
        );

        if (response.status === 201 || response.status === 200) {
          props.onHide();
          window.location.reload();
          props.onCloseCallback()
          dispatch(
            showSnackbar({
              message: "Selected data paired successfully !",
              severity: "success",
            })
          );
        }
      } else {
        dispatch(
          showSnackbar({
            message: "Please select atleast one record to pair.",
            severity: "error",
          })
        );
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message:
            "Error occurred ! Unable to create pair. Please try again later.",
          severity: "error",
        })
      );
    }
  }
  
  return (
    props.mappedvalues && (
      <Modal
        {...props}
        size="xl"
        centered
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <h5>Possibilities of Mapping</h5>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <TableContainer component={Paper} className={classes.tableContainer}>
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center" className={classes.tableHeaderCell}>
                    {/* it has to be an empty table cell */}
                  </TableCell>
                  <TableCell align="center" className={classes.tableHeaderCell}>
                    Role
                  </TableCell>
                  <TableCell align="center" className={classes.tableHeaderCell}>
                    Name
                  </TableCell>
                  <TableCell hidden align="center" className={classes.tableHeaderCell}>
                    Id
                  </TableCell>
                  {/* <TableCell align="center" className={classes.tableHeaderCell}>
                    Batch Name & Id
                  </TableCell> */}
                  <TableCell align="center" className={classes.tableHeaderCell}>
                    Languages
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {props.mappedvalues
                  // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    // console.log(isItemSelected);
                    const isItemSelected = isSelected(index);
                    const labelId = `enhanced-table-checkbox-${index}`;
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        selected={isItemSelected}
                        key={index}
                      >
                        <TableCell align="center" padding="checkbox">
                          <Checkbox
                            checked={isItemSelected}
                            inputProps={{ "aria-labelledby": labelId }}
                            onChange={(event) => handleClick(event, index)}
                          />
                        </TableCell>
                        <TableCell align="center" component="th" scope="row">
                          <Grid>
                            <Grid item className={classes.teacherName}>
                              {row.teacherRole}
                            </Grid>
                            <br />
                            <Grid item className={classes.studentName}>
                              {row.studentRole}
                            </Grid>
                          </Grid>
                        </TableCell>
                        <TableCell align="center">
                          <Grid>
                            <Grid item>{row.teacherName}</Grid>
                            <br />
                            <Grid item>{row.studentName}</Grid>
                          </Grid>
                        </TableCell>
                        <TableCell hidden align="center">
                          <Grid>
                            <Grid item>{row.teacherId}</Grid>
                            <br />
                            <Grid item>{row.studentId}</Grid>
                          </Grid>
                        </TableCell>
                        {/* <TableCell width={250}>
                          
                          
                          <TextField
                            label="Select Batch"
                            // disabled={!isItemSelected}
                            select 
                            fullWidth 
                            size='small'
                            value={props.mappedvalues[index].teacherBatchId}
                            onChange={(e) => {
                              // console.log(e.target);
                              let batchName = row.teacherBatchLists.filter((item) => {
                                return item.batch_ids === e.target.value
                              })[0].batch_name;
                              return props.setMappedValues(prevState => {
                                return prevState.map((item, mapindex) => {
                                  return index === mapindex ? 
                                    {...item,  teacherBatchId: e.target.value, teacherBatchName: batchName} :
                                    {...item}
                                })                              
                              })
                            }} 
                            
                          >
                            {row.teacherBatchLists.map((batch, index) => (<MenuItem key={index} value={batch.batch_ids}>{batch.batch_name}</MenuItem>))}

                          </TextField>
                        </TableCell> */}
                        <TableCell align="center">
                          {row.commonLanguages}
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
            {/* <TablePagination
              rowsPerPageOptions={[5, 10, 20]}
              component="div"
              count={data.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            /> */}
          </TableContainer>
        </Modal.Body>

        <Modal.Footer>
          <div>
            <Button
              type="button"
              variant="light"
              onClick={() => closeModal(props)}
            >
              CLOSE
            </Button>
            <Button
              type="submit"
              variant="primary"
              className="mx-3"
              onClick={() => postMappedData()}
            >
              PROCEED
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    )
  );
}

export default MappedDataModal;
